import { EiTableColumn, EiTableRow } from '../models/ei-table.model'

/**
 * Represents the currently editing cell in the table.
 */
export type EditingCell = { rowId: string | number; colKey: string } | null

/**
 * Create updated row with new cell value.
 */
export function createUpdatedRow(
    row: EiTableRow,
    column: EiTableColumn,
    newValue: unknown,
): EiTableRow {
    if (column.valueSetter) {
        return column.valueSetter(row, newValue)
    }
    return { ...row, [column.key]: newValue }
}
